var _defs, _path, _line, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDoublearrowCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4d4d4d;\n        stroke: #4d4d4d;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n        stroke-width: 18px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M754.21,245.62l-82.86,22.2c-.18,.05-.24,.27-.11,.4l60.66,60.66c.13,.13,.35,.07,.4-.11l22.2-82.86c.05-.18-.11-.34-.29-.29Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 245.49,
    y1: 754.39,
    x2: 712.49,
    y2: 287.39
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.95,795.92l82.86-22.2c.18-.05,.24-.27,.11-.4l-60.66-60.66c-.13-.13-.35-.07-.4,.11l-22.2,82.86c-.05,.18,.11,.34,.29,.29Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublearrowCurve);
export default __webpack_public_path__ + "static/media/doublearrow-curve.be7a949d2cda1b8527887339a2ff029b.svg";
export { ForwardRef as ReactComponent };